import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FailedEmailsRecordsState } from './failed-emails.reducer';

export const selectDataState = createFeatureSelector<FailedEmailsRecordsState>('failedEmailsRecords');

export const selectData = createSelector(
    selectDataState,
    (state: FailedEmailsRecordsState) => state.listData
);

export const selectDataLoading = createSelector(
    selectDataState,
    (state: FailedEmailsRecordsState) => state.loading
);

export const checkUpdation = createSelector(
    selectDataState,
    (state: FailedEmailsRecordsState) => state.updation
);

export const selectDataError = createSelector(
    selectDataState,
    (state: FailedEmailsRecordsState) => state.error
);